module.exports = __webpack_public_path__ + "img/core-1.9bff9e3.png";